<template>
  <Row class="-pointer-" :nav-titles="navTitles" height="43px">
    <Cell class="-full-border- rating-table-profile" :text="false">
      <Avatar
        class="rating-table-profile__img"
        :src="user.avatar"
        :is-leader="user.id === leader"
      />
      <div class="rating-table-profile__info">
        <p class="rating-table-profile__title">
          {{ userName }}
        </p>
        <p class="rating-table-profile__subtitle">
          {{ user.city }}
        </p>
      </div>
    </Cell>
    <Cell class="-full-border-" :title="user.faculty">
      {{ user.faculty || 'Нет факультета / сборной' }}
    </Cell>
    <Cell class="-full-border-">
      {{ user.niche || 'Нет ниши' }}
    </Cell>
    <Cell class="-full-border-">
      {{ revenue }}
    </Cell>
    <Cell class="-full-border-">
      {{ profit }}
    </Cell>
  </Row>
</template>

<script>
import Row from '@/views/Rating/components/Table/Row';
import Cell from '@/views/Rating/components/Table/Cell';
import Avatar from './Avatar';
import numberFormat from '@/filters/numberFormat.filter';

export default {
  components: {
    Row,
    Cell,
    Avatar
  },
  props: {
    navTitles: {},
    user: {
      type: Object,
      default: () => ({})
    },
    leader: {
      type: [Boolean, Number],
      default: false
    }
  },
  computed: {
    userName() {
      if (this.user.name || this.user.lastname) {
        return `${this.user.name} ${this.user.lastname}`;
      }
      return 'Аноним';
    },
    revenue() {
      if (this.user.revenue !== null) {
        return `${numberFormat(this.user.revenue)} ₽`;
      }
      return 'Нет данных';
    },
    profit() {
      if (this.user.profit !== null) {
        return `${numberFormat(this.user.profit)} ₽`;
      }
      return 'Нет данных';
    }
  }
};
</script>
